<template>
  <div class="monthly-fee-report">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-s-data"></i> Monthly Fee Report</span>
      </div>

      <el-form :inline="true" :model="query" size="medium">
        <el-form-item label="Currency">
          <el-select v-loading="loadingCurrency" v-model="query.currency" placeholder="Currenct" style="width:100px">
            <el-option value="" label="All"></el-option>
            <el-option v-for="item in currencys" :key="item.uid" :value="item.currency" :label="item.currency.toUpperCase()"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="Month">
          <el-select v-model="query.month" placeholder="Month" style="width:100px">
            <el-option
                v-for="item in month_option"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Year">
          <el-select v-model="query.year" placeholder="Year" style="width:100px">
            <el-option
                v-for="item in year_option"
                :key="item.value"
                :label="item.value"
                :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" :loading="loading" @click="getMonthlyChargeData()">Query</el-button>
          <el-button type="success" icon="el-icon-download" @click="Export()">Export</el-button>
        </el-form-item>
      </el-form>

      <el-row :gutter="15" class="panel-group" v-if="sumData">
        <el-col :xs="24" :sm="12" :lg="4" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-open">
              <svg-icon icon-class="bank" class-name="card-panel-icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">Monthly Fee</div>
              <div class="card-panel-num">
                {{ sumData.monthlyTotal.count }}
              </div>
              <div class="card-panel-amount" v-if="query.currency">
                {{ currencyFormat(sumData.monthlyTotal.totalamount, query.currency) }}
              </div>
            </div>
          </div>
        </el-col>
        <!-- <el-col :xs="24" :sm="12" :lg="4" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-open">
              <svg-icon icon-class="compliance" class-name="card-panel-icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">Compliance Fee</div>
              <div class="card-panel-num">
                {{ sumData.complianceTotal.count }}
              </div>
              <div class="card-panel-amount" v-if="query.currency">
                {{ currencyFormat(sumData.complianceTotal.totalamount, query.currency) }}
              </div>
            </div>
          </div>
        </el-col> -->
        <el-col :xs="24" :sm="12" :lg="4" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-open">
              <svg-icon icon-class="closed" class-name="card-panel-icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">Closed</div>
              <div class="card-panel-num">
                {{ sumData.closedAccount.count }}
              </div>
              <div class="card-panel-amount" v-if="query.currency">
                {{ currencyFormat(sumData.closedAccount.totalamount, query.currency) }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="4" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-collected">
              <svg-icon icon-class="collected" class-name="card-panel-icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">Collected</div>
              <div class="card-panel-num">
                {{ sumData.collected.count }}
              </div>
              <div class="card-panel-amount" v-if="query.currency">
                {{ currencyFormat(sumData.collected.totalamount, query.currency) }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="4" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-missing">
              <svg-icon icon-class="missing" class-name="card-panel-icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">Missing</div>
              <div class="card-panel-num">
                {{ sumData.missing.count }}
              </div>
              <div class="card-panel-amount" v-if="query.currency">
                {{ currencyFormat(sumData.missing.totalamount, query.currency) }}
              </div>
            </div>
          </div>
        </el-col>
        <el-col :xs="24" :sm="12" :lg="4" class="card-panel-col">
          <div class="card-panel">
            <div class="card-panel-icon-wrapper icon-insufficient">
              <svg-icon icon-class="savings" class-name="card-panel-icon" />
            </div>
            <div class="card-panel-description">
              <div class="card-panel-text">Insufficient</div>
              <div class="card-panel-num">
                {{ sumData.insufficientPayment.count }}
              </div>
              <div class="card-panel-amount" v-if="query.currency">
                {{ currencyFormat(sumData.insufficientPayment.totalamount, query.currency) }}
              </div>
            </div>
          </div>
        </el-col>
      </el-row>


      <el-table 
          v-loading="loading" 
          :data="tableData" 
          border 
       
          :row-class-name="tableRowStatus">
          <el-table-column prop="bankholderID" label="BankholderID" width="180" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="project_name" label="Project" width="300" header-align="center" > </el-table-column>
          <el-table-column prop="member_code" label="Member" width="100" header-align="center" align="center" > </el-table-column>
          <el-table-column prop="flag_compliance" label="Type" width="100" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="currency" label="Currency" width="100" header-align="center" align="center" >
            <template slot-scope="scope">
              {{ scope.row.currency && scope.row.currency.toUpperCase() }}
            </template>
          </el-table-column>
          <el-table-column prop="created_date" label="Created" width="120" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="bank_status" label="Status" width="100" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="for_month" label="For Month" width="100" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="charge" label="Charge" width="100" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="credit" label="Collect from Bonus" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="amount" label="Collect from customer" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="contract_chargeamount" label="Collect from contract" width="150" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="paid_date" label="Paid" width="120" header-align="center" align="center"> </el-table-column>
          <el-table-column prop="reason" label="Reason" header-align="center" align="center"> </el-table-column>
        </el-table>

        <div class="pagination-block">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-sizes="[10, 20, 30, 50, 100, 200]"
            :page-size="pageSize"
            layout="prev, pager, next, jumper, sizes, total"
            :total="total">
          </el-pagination>
        </div>

    </el-card>
  </div>
</template>

<script>
import { getCurrencyList } from '@/api/currency'
import { getMonthlyCharge, getExcelFile } from "@/api/report";
import { currentYear, currentMonth , padStart, currencyFormat} from '@/utils'
export default {
  props:{
    project: String
  },
  watch: {
      project(val, old) {
        this.query.project_uid = val;
        this.project = val;
        this.dropdownMonthYear()
        this.getCurrencyList() 
        this.getMonthlyChargeData() 
      }
  },
  computed: {
    roleSuperAdmin() {
      return this.roleAuth([this.role.spadmin]);
    },
    rolePrice(){
      return this.roleAuth([this.role.spadmin, this.role.admin]);
    }
  },
  data(){
    return {
      query: {
        project_uid: this.project,
        currency : "",
        month: currentMonth(),
        year: currentYear(),
        type: "monthlyfee"
      },
      month_option: [],
      year_option: [],
      dataReport: [],
      tableData: [],
      loading: false,
      loadingCurrency: false,
      currentPage: 1,
      pageSize: 50,
      total: 0,
      sumData : null,
      currencys: []
    }
  },
  methods:{
    getMonthlyChargeData(){
      this.loading = true
      this.tableData = [];
      this.dataReport =  []
      this.sumData = null
      this.total = 0
      this.GetProject()
      getMonthlyCharge(this.query).then(({result, data})=>{
        this.loading = false
        if(result && typeof data === "object"){
          this.dataReport = data.data
          this.sumData = data.sum
          this.total = data.data ? data.data.length : 0
          this.Pagination()
        }
      })
    },

    getCurrencyList(){
      if(!this.project) return;
      this.loadingCurrency = true;
      getCurrencyList(this.project).then(({result, data})=>{
        this.loadingCurrency = false
        if (result) {
          this.currencys = data;
          this.query.currency = ""
        }
      })
    },

    GetProject(){
      this.query.project_uid = this.project || ""
      this.dataReport = []
    },

    Pagination(){
      if(!this.dataReport) return
      this.tableData = this.dataReport.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
    },
    Export(){
      getExcelFile(this.query)
    },
    tableRowStatus({row}) {
      return row.bank_status;
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.Pagination()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.Pagination()
    },
    dropdownMonthYear() {
      this.month_option = []
      this.year_option = []
      for (let m = 1; m <= 12; m++) {
        this.month_option.push({ value: padStart(m, 2) });
      }

      for (let y = (currentYear() - 5); y <= currentYear(); y++) {
        this.year_option.push({ value: y.toString() });
      }
    },
    currencyFormat(num, currency){
      return currencyFormat(num, currency)
    }
  },
  created(){
    // this.getMonthlyChargeData()
    this.dropdownMonthYear()
    this.getCurrencyList()    
  }
}
</script>

<style lang="scss">
.monthly-fee-report{
    .el-table .closed {
    background: #ffdede;
  }

  .el-table .suspended {
    background: #f3f3f3;
  }

  .pagination-block{
    margin-top: 10px;
  }

  .panel-group {
  margin-top: 18px;

  .card-panel-col {
    margin-bottom: 18px;
  }

  .card-panel {
    height: 108px;
    font-size: 12px;
    position: relative;
    overflow: hidden;
    color: #666;
    background: #fff;
    box-shadow: 4px 4px 40px rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.05);
    
    &:hover {
      cursor: pointer;
      background-color: #e8f3ff;
      -webkit-box-shadow: 4px 4px 40px rgba(0,0,0,0.05);
      box-shadow: 4px 4px 40px #409eff29;
      border-color: #deeeff;
      -webkit-transition: background-color .2s ease-out;
      transition: background-color .2s ease-out;
    }

    .icon-open {
      color: #40c9c6;
    }

    .icon-missing {
      color: #f4516c;
    }

    .icon-insufficient {
      color: #e6a23c;
    }

    .icon-collected {
      color: #36a3f7;
    }

    .card-panel-icon-wrapper {
      position: absolute;
      margin: 14px 0 0 6px;
      padding: 10px;
      transition: all 0.38s ease-out;
      border-radius: 6px;
    }

    .card-panel-icon {
      float: left;
      font-size: 45px;
    }

    .card-panel-description {
      float: right;
      font-weight: bold;
      margin: 10px;
      margin-top: 20px;
      margin-left: 0px;

      .card-panel-text {
        line-height: 18px;
        color: rgba(0, 0, 0, 0.45);
        font-size: 16px;
        margin-bottom: 5px;
        text-align: right;
      }

      .card-panel-num {
        font-size: 20px;
        text-align: right;
        margin-bottom: 7px;
      }
      .card-panel-amount {
        text-transform: uppercase;
        font-size: 14px;
        text-align: right;
        margin-bottom: 7px;
        color: 969696;
      }
      .card-panel-acc {
        text-align: right;
        margin-bottom: 3px;
      }
      .card-panel-type {
        text-align: right;
      }
    }
  }
}

@media (max-width: 550px) {
  // .card-panel-description {
  //   display: none;
  // }

    .card-panel-icon-wrapper {
    float: none !important;
    width: 0px;
    height: 0px;
    padding: 0 !important;
    margin: 0 !important;

    .svg-icon {
      display: block;
      margin: 0px auto !important;
      float: none !important;
    }
  }
}
}
</style>